<template>
  <div class="locations">
    <NavigationBar />
    <div class="table-and-map columns is-gapless is-hidden-mobile force-last-child">
      <div class="column is-one-fifth left-panel">
        <LocationsTable class="table" />
      </div>
      <div class="column main-panel">
        <OfficeMap class="map" />
      </div>
    </div>
    <div class="table-and-map is-hidden-tablet">
      <div class="main-panel">
        <OfficeMap class="map" />
      </div>
      <div class="bottom-panel">
        <LocationsTable class="table" />
      </div>
    </div>
  </div>
</template>

<script>
import OfficeMap from "@/components/OfficeMap.vue";
import LocationsTable from "@/components/LocationsTable.vue";
import NavigationBar from "@/components/NavigationBar.vue";

export default {
  name: "locations",
  components: { OfficeMap, LocationsTable, NavigationBar },
  data() {
    return {
      authorized_to_slack: false
    };
  }
};
</script>

<style scoped>
.locations {
  height: 100vh;
}

@media (min-width: 768px) {
  .table-and-map {
    display: flex;
    height: calc(100vh - 57px);
  }
  .table {
    height: calc(100vh - 57px);
    overflow-y: auto;
  }
  .map {
    height: calc(100vh - 57px);
  }
  .left-panel {
    border-right: 1px solid #dbdbdb;
    min-width: 340px;
  }
}

@media (max-width: 768px) {
  .locations {
    height: var(--app-height);
  }
  .table-and-map {
    display: flex;
    flex-flow: column;
    height: calc((var(--app-height)) - 57px);
  }
  .table {
    height: 100%;
    overflow-y: auto;
  }
  .map {
    border-bottom: 1px solid #dbdbdb;
    height: 100%;
  }
  .main-panel {
    height: 65%;
  }
  .bottom-panel {
    height: 35%;
  }
}

/* To show the scrollbar on mobile, always. */
::-webkit-scrollbar {
  -webkit-appearance: none;
}
::-webkit-scrollbar:vertical {
  width: 12px;
}
::-webkit-scrollbar:horizontal {
  height: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}
</style>
